// extracted by mini-css-extract-plugin
export default {"container":"Acceso_container__BMIsI","card":"Acceso_card__j7fKO","titleHeader":"Acceso_titleHeader__8RO2c","title":"Acceso_title__UtM1l","button":"Acceso_button__6L7oS"};